import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { services, serviceCategories } from '@/mocks/services';

const ServicesPage = () => (
  <div className="min-h-screen bg-brand-cream font-sans">
    <Navbar />

    {/* Hero */}
    <section className="relative pt-36 pb-20 bg-brand-dark overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/badf677844baf2b9b5c79041360c1671.jpg"
          alt="Valley View Construction Services in Elkhart Indiana"
          className="w-full h-full object-cover object-top opacity-30"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-brand-dark/70 to-brand-dark" />
      </div>
      <div className="relative max-w-4xl mx-auto px-4 md:px-8 text-center">
        <div className="inline-flex items-center gap-2 px-3 py-1.5 border border-brand-amber/30 rounded-full mb-5">
          <span className="text-xs font-semibold text-brand-amber uppercase tracking-widest">What We Do</span>
        </div>
        <h1 className="font-serif text-4xl md:text-6xl font-bold text-white mb-6">
          All Our <span className="text-brand-amber italic">Services</span>
        </h1>
        <p className="text-white/65 text-lg max-w-2xl mx-auto">
          Expert masonry, construction, and hardscape services for residential and commercial clients throughout Michiana. 12 specialty services, one trusted team.
        </p>
      </div>
    </section>

    {/* Services by Category */}
    <section className="py-20 max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
      {serviceCategories.map((cat) => (
        <div key={cat.name} className="mb-16">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-10 h-10 flex items-center justify-center bg-brand-amber/15 rounded-xl">
              <i className={`${cat.icon} text-brand-amber text-lg`} />
            </div>
            <div>
              <h2 className="font-serif text-2xl font-bold text-brand-dark">{cat.name}</h2>
            </div>
            <div className="flex-1 h-px bg-brand-cream-dark ml-4" />
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {cat.services.map((sid) => {
              const svc = services.find((s) => s.id === sid);
              if (!svc) return null;
              return (
                <Link
                  to={`/services/${svc.id}`}
                  key={svc.id}
                  className="group bg-white rounded-2xl overflow-hidden border border-brand-cream-dark hover:border-brand-amber/30 transition-all duration-300 cursor-pointer"
                >
                  <div className="relative h-48 overflow-hidden">
                    <img
                      src={svc.image}
                      alt={`${svc.name} - Valley View Construction Elkhart Indiana`}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-brand-black/60 to-transparent" />
                    <span className="absolute top-3 left-3 px-2.5 py-1 bg-brand-amber rounded-md text-white text-xs font-semibold">{svc.category}</span>
                    <div className="absolute bottom-3 right-3 w-8 h-8 flex items-center justify-center bg-brand-amber rounded-full opacity-0 group-hover:opacity-100 transition-opacity">
                      <i className="ri-arrow-right-line text-white text-sm" />
                    </div>
                  </div>
                  <div className="p-5">
                    <div className="flex items-center gap-2 mb-2">
                      <div className="w-6 h-6 flex items-center justify-center">
                        <i className={`${svc.icon} text-brand-amber`} />
                      </div>
                      <h3 className="font-semibold text-brand-dark text-base">{svc.name}</h3>
                    </div>
                    <p className="text-brand-stone text-sm leading-relaxed mb-4">{svc.shortDesc}</p>
                    <div className="flex items-center justify-between">
                      <span className="text-xs font-semibold text-brand-amber flex items-center gap-1">
                        Property Value: {svc.propertyValueBoost}
                      </span>
                      <span className="text-xs text-brand-amber font-semibold flex items-center gap-1 group-hover:gap-2 transition-all">
                        Learn More <i className="ri-arrow-right-line" />
                      </span>
                    </div>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      ))}
    </section>

    {/* CTA */}
    <section className="bg-brand-dark py-16">
      <div className="max-w-3xl mx-auto px-4 text-center">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-white mb-4">
          Ready to Start Your Project?
        </h2>
        <p className="text-white/60 mb-8">Call us or fill out our contact form for a free, no-obligation consultation and quote.</p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a href="tel:+15744096118" className="px-8 py-4 bg-brand-amber hover:bg-brand-amber-light text-white font-semibold rounded-lg transition-colors whitespace-nowrap flex items-center justify-center gap-2">
            <i className="ri-phone-fill" /> Call 574-409-6118
          </a>
          <Link to="/#contact" className="px-8 py-4 border-2 border-white/20 hover:border-brand-amber text-white font-semibold rounded-lg transition-all whitespace-nowrap flex items-center justify-center gap-2">
            <i className="ri-mail-line" /> Get Free Quote
          </Link>
        </div>
      </div>
    </section>

    <Footer />
  </div>
);

export default ServicesPage;
